export default __webpack_public_path__ + "static/media/delete-icon.d1504778.svg";